import { CircularProgress } from 'library/loaders';
import { IllustrationView, SomethingWentWrongIllustration } from 'modules/shared/features/illustration';
import useAuthSelector from 'modules/shared/hooks/useAuthSelector';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authActions } from 'store/auth';

const PulseLoginPage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [searchParams] = useSearchParams();

    const tokenKey = searchParams.get('t');

    const { token } = useAuthSelector();

    useEffect(() => {
        if (tokenKey) {
            dispatch(authActions.login({ token: tokenKey, expiryInMinutes: 30 }));
        }

        if (token) {
            navigate('/dashboard', { replace: true });
        }
    }, [dispatch, navigate, token, tokenKey]);

    if (!tokenKey)
        return (
            <IllustrationView
                className="justify-center h-screen"
                illustration={<SomethingWentWrongIllustration />}
                title="Oops, something went wrong"
                message={
                    <>
                        An error occurred while processing your request. Please try again.
                        <div className="mt-1">
                            <a
                                className="text-primary font-medium cursor-pointer"
                                onClick={() => navigate('/', { replace: true })}
                            >
                                Go back home
                            </a>
                        </div>
                    </>
                }
            />
        );

    return (
        <section>
            <div className="fixed top-0 left-0 flex flex-col items-center justify-center h-screen w-full bg-card-color">
                <div className="flex items-center justify-center w-14 h-14 rounded-lg text-primary ">
                    <CircularProgress size={32} />
                </div>
            </div>
        </section>
    );
};

export default PulseLoginPage;
